import { isEmpty } from 'lodash';
import {
  constructHeroImageURL,
  getProductPrimaryOptionId,
  getDefaultOptionData,
  getSKUForMaterialOrOptionId,
  convertSkuToImageURLValidSku,
  getValidOptionTypeIdForHeroOptionImage,
} from 'commons/productUtils';
import {
  WOOD_PRODUCT_OPTION_ID,
  FINISH_PRODUCT_OPTION_ID,
  SIZE_PRODUCT_OPTION_ID,
  FRAME_PRODUCT_OPTION_ID,
} from 'commons/constants';
import constructImageURLsForVariant from 'commons/constructImageURLsForVariant';
import { getFabricOptionValueByPartSku } from '../useProductCardSwatches/utils';
import { getProductImageAngle } from '../useProductCardSwatchPhotos/utils';

export const getConstructedImagesForMaterial = ({
  product,
  options,
  forMaterial,
  forMaterialType,
  layout,
  defaultAngle,
  showVariation,
  isProductOOS,
  listName = '',
  fabricData = [],
  display_option_images = false,
}) => {
  if (layout === 'category' && isProductOOS) {
    return [];
  }
  if (listName === 'MaterialSwatches' && !fabricData?.length) {
    return [];
  }
  const [ , optionId ] = display_option_images
    ? getValidOptionTypeIdForHeroOptionImage(options)
    : [];

  const optionTypeId =
    display_option_images && optionId
      ? optionId
      : getProductPrimaryOptionId(options, product);

  const productAngle = defaultAngle || getProductImageAngle({ product });
  let productImages = {};
  let optionSku = null;
  let skuVal = {};
  let finalForMaterial = '';
  if (forMaterialType && forMaterial) {
    finalForMaterial = forMaterial || '';
    skuVal = getSKUForMaterialOrOptionId({
      options,
      forMaterial: forMaterial.trim(),
      optionTypeId,
      fabricData:
        listName === 'MaterialSwatches' && fabricData?.length ? fabricData : [],
    });
  }

  if (showVariation) {
    const upholsteryOption = getFabricOptionValueByPartSku({
      showVariation,
      options,
      primaryOptionTypeId: optionTypeId,
    });
    if (upholsteryOption) {
      const finalSku = convertSkuToImageURLValidSku({
        upholsterySku: upholsteryOption.sku,
        fullSku: showVariation,
        options,
        optionTypeId,
      });
      skuVal.sku = finalSku;
      finalForMaterial = upholsteryOption.value;
    }
  }

  if (
    ((!forMaterial || !forMaterialType) && !showVariation) ||
    (((!!forMaterialType && !!forMaterial) || !!showVariation) &&
      isEmpty(skuVal))
  ) {
    const defaultOptionData = getDefaultOptionData(
      options,
      display_option_images,
    );
    skuVal.sku = defaultOptionData.finalSku;
    finalForMaterial = defaultOptionData.optionName;
    if (
      [
        WOOD_PRODUCT_OPTION_ID,
        FINISH_PRODUCT_OPTION_ID,
        SIZE_PRODUCT_OPTION_ID,
        FRAME_PRODUCT_OPTION_ID,
      ].includes(optionId)
    ) {
      finalForMaterial = '';
    }
  }

  optionSku = !isEmpty(skuVal) ? skuVal.sku : '';

  productImages = constructHeroImageURL(
    product,
    options,
    optionSku,
    productAngle,
    true,
    !!display_option_images
  );

  productImages = {
    ...productImages,
    ...constructImageURLsForVariant(
      product.id,
      optionSku,
      product.name,
      finalForMaterial,
      productAngle,
      null,
      true
    ),
  };

  return productImages;
};
